import React from 'react';

import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    maxWidth: 520,
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    padding: theme.spacing(2.5, 3, 1.5),
  },
  close: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  content: {
    padding: theme.spacing(0, 3, 3),
    display: 'flex',
    justifyContent: 'center',
  },
  imageWrapper: {
    width: '100%',
    backgroundColor: theme.palette.common.white,
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: theme.shadows[1],
    display: 'flex',
    justifyContent: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    maxHeight: '80vh',
    display: 'block',
  },
}));

type PreviewDialogProps = {
  open: boolean;
  title: string;
  imageUrl: string;
  onClose: () => void;
};

const PreviewDialog = ({ open, title, imageUrl, onClose }: PreviewDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      classes={{ paper: classes.paper }}>
      <IconButton className={classes.close} onClick={onClose}>
        <CloseOutlinedIcon />
      </IconButton>
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        <Box className={classes.imageWrapper}>
          <img src={imageUrl} alt={title} className={classes.image} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
